const columns = [
  {
    headerLabel: 'rotativeInventory.dtInventory',
    type: 'general',
    field: 'dtInventory',
    className: 'small-column align-left',
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'rotativeInventory.hrInventory',
    type: 'general',
    field: 'hrInventory',
    className: 'small-column align-left',
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'rotativeInventory.dsBranch',
    type: 'general',
    field: 'dsBranch',
    className: 'align-left',
    render: false,
    fixed: true,
  },
  {
    headerLabel: 'rotativeInventory.cdLm',
    type: 'general',
    field: 'cdLm',
    className: 'small-column align-left',
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'rotativeInventory.dsProduct',
    type: 'general',
    field: 'dsProduct',
    className: 'align-left',
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'rotativeInventory.dsLot',
    type: 'general',
    field: 'dsLot',
    className: 'align-left',
    render: false,
    fixed: true,
  },
  {
    headerLabel: 'rotativeInventory.section',
    type: 'general',
    field: 'section',
    className: 'align-left',
    render: false,
    fixed: true,
  },
  {
    headerLabel: 'rotativeInventory.c50v2',
    type: 'decimal-p3',
    field: 'c50',
    className: 'align-right',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.c50Countedv2',
    type: 'decimal-p3',
    field: 'c50Counted',
    className: 'align-right',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.qtDifferencev2',
    type: 'decimal-p3',
    field: 'qtDifference',
    className: 'align-right',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.c010',
    type: 'decimal-p3',
    field: 'c10',
    className: 'align-right',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.dpac',
    type: 'currency',
    field: 'dpacValue',
    className: 'align-right',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.vlDifference',
    type: 'currency',
    field: 'vlDifference',
    className: 'align-right',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.accurrancy',
    type: 'index',
    field: 'accurrancy',
    className: 'small-column align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.integrated',
    type: 'general',
    field: 'integrated',
    className: 'small-column align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.dsJustification',
    type: 'general',
    field: 'dsJustification',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.dsJustificationNotCounted',
    type: 'general',
    field: 'dsJustificationNotCounted',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.ldap',
    type: 'general',
    field: 'ldap',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.warehouse',
    type: 'general',
    field: 'warehouse',
    className: 'small-column align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'rotativeInventory.provider',
    type: 'general',
    field: 'provider',
    className: 'align-left',
    render: true,
    fixed: false,
  },
]

export default columns
